// Central, reversible visibility toggles for duplicated marketing sections.
// Flip a value to `true` to bring the section back on that page.
export const SECTIONS = {
  // "Not the usual recruiter playbook" — kept on For Startups, hidden on Home (duplicate).
  homeRecruiterPlaybook: false,
  // "Explore Magnus Kor" link hub — nav + footer already do this.
  homeExploreHub: false,
  // Case studies live only on the Home page — hidden on For Startups.
  forStartupsCaseStudies: false,
};
